import { useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import { MESSAGE_ICON_BY_TYPE } from '../../constants';
import { notificationCenterActions } from '../../store';
import { useGetMoreInfoAction } from './useGetMoreInfoAction';

import styles from './index.module.css';

const { READ_NOTIFICATION, SET_IS_NOTIFICATIONS_LIST_OPENED } =
  notificationCenterActions;

export const Notification = ({ notification, className } = {}) => {
  const { t, f } = useI18n();
  const { notificationId, date, notificationText, category } = notification;

  const moreInfoAction = useGetMoreInfoAction(notification);
  const hasMoreInfo = moreInfoAction != null;
  const DATE_FORMATS_TYPES = f.getFormats();
  const formattedDate = useMemo(() => {
    if (
      f.getDateTime({ date }).toFormat(DATE_FORMATS_TYPES.dd_MM) ===
      f.getDateTime().toFormat(DATE_FORMATS_TYPES.dd_MM)
    ) {
      return t('web.notifications.today.datelabel');
    }

    return f.getDateTime({ date }).toFormat(DATE_FORMATS_TYPES.dd_MM);
  }, [DATE_FORMATS_TYPES.dd_MM, date, f, t]);

  const onClose = useCallback(
    (e) => {
      e.stopPropagation();
      READ_NOTIFICATION(notificationId);
    },
    [READ_NOTIFICATION, notificationId]
  );

  const onClick = useCallback(() => {
    READ_NOTIFICATION(notificationId);
    moreInfoAction();
    SET_IS_NOTIFICATIONS_LIST_OPENED(false);
  }, [
    READ_NOTIFICATION,
    SET_IS_NOTIFICATIONS_LIST_OPENED,
    moreInfoAction,
    notificationId
  ]);

  return (
    <div
      className={clsx(styles.root, className, hasMoreInfo && styles.pointer)}
      onClick={hasMoreInfo ? onClick : null}
    >
      <Icon
        name={MESSAGE_ICON_BY_TYPE[category]}
        size="m"
        color="txt_color_1"
        className={styles.icon}
      />
      <Box
        direction="column"
        gap="xs"
        top="xs"
        className={styles.contentContainer}
      >
        <AText breed="R" size="s" color="txt_color_7">
          {formattedDate}
        </AText>
        <AText breed="R" size="s" color="txt_color_1">
          {notificationText}
        </AText>
      </Box>

      {hasMoreInfo && (
        <AText
          breed="BU"
          size="s"
          color="btn_primary_bg_color_1"
          className={styles.moreInfo}
        >
          {t('web.notifications.moreinfo.btn')}
        </AText>
      )}

      <Box className={styles.close}>
        <Icon
          size="xs"
          name="icons/general/action/close"
          color="txt_color_7"
          onClick={onClose}
        />
      </Box>
    </div>
  );
};
